const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/account/activate.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Button } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/account/activate")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});